import { createSlice } from "@reduxjs/toolkit";

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: {
    isSignupLoading: false,
    isSigninLoading: false,
    isForgotPasswordLoading: false,
    isVerifyTokenPasswordLoading: false,
    isResetPasswordLoading: false,
    authDetails: null,
    authToken: null,
    isRetrieveTokenLoading: false,
    isLogoutLoading: false,
  },
  reducers: {
    // retrieve token
    setRetrieveTokenLoading: (state) => {
      state.isRetrieveTokenLoading = true;
    },
    setRetrieveTokenSucess: (state, action) => {
      state.authToken = action.payload;
      state.isRetrieveTokenLoading = false;
    },
    setRetrieveTokenFailure: (state) => {
      state.isRetrieveTokenLoading = false;
    },
    // signup
    setSignUpLoading: (state) => {
      state.isSignupLoading = true;
    },
    setSignUpSuccess: (state, action) => {
      state.isSignupLoading = false;
      state.authDetails = action.payload;
      state.authToken = action.payload.authToken;
    },
    setSignUpFailure: (state) => {
      state.isSignupLoading = false;
    },
    // sign in
    setSignInLoading: (state) => {
      state.isSigninLoading = true;
    },
    setSignInSuccess: (state, action) => {
      state.isSigninLoading = false;
      state.authDetails = action.payload;
      state.authToken = action.payload.authToken;
    },
    setSignInFailure: (state) => {
      state.isSigninLoading = false;
    },
    // forgotPassword
    setForgotPasswordLoading: (state) => {
      state.isForgotPasswordLoading = true;
    },
    setForgotPasswordSuccess: (state) => {
      state.isForgotPasswordLoading = false;
    },
    setForgotPasswordFailure: (state) => {
      state.isForgotPasswordLoading = false;
    },
    // verifyTokenPassword
    setVerifyTokenPasswordLoading: (state) => {
      state.isVerifyTokenPasswordLoading = true;
    },
    setVerifyTokenPasswordSuccess: (state) => {
      state.isVerifyTokenPasswordLoading = false;
    },
    setVerifyTokenPasswordFailure: (state) => {
      state.isVerifyTokenPasswordLoading = false;
    },
    // reset password
    setResetPasswordLoading: (state) => {
      state.isResetPasswordLoading = true;
    },
    setResetPasswordSuccess: (state) => {
      state.isResetPasswordLoading = false;
    },
    setResetPasswordFailure: (state) => {
      state.isResetPasswordLoading = false;
    },
    setLogout: (state) => {
      state.authDetails = null;
      state.authToken = null;
      state.isRetrieveTokenLoading = false;
    },
    // these are for api only
    setLogoutLoading: (state) => {
      state.isLogoutLoading = true;
    },
    setLogoutSuccess: (state) => {
      state.isLogoutLoading = false;
    },
    setLogoutFailure: (state) => {
      state.isLogoutLoading = false;
    },
  },
});

export const {
  setSignUpLoading,
  setSignUpSuccess,
  setSignUpFailure,
  setSignInLoading,
  setSignInSuccess,
  setSignInFailure,
  setForgotPasswordLoading,
  setForgotPasswordSuccess,
  setForgotPasswordFailure,
  setVerifyTokenPasswordLoading,
  setVerifyTokenPasswordSuccess,
  setVerifyTokenPasswordFailure,
  setResetPasswordLoading,
  setResetPasswordSuccess,
  setResetPasswordFailure,
  setRetrieveTokenSucess,
  setLogout,
  setRetrieveTokenLoading,
  setTokenLoading,
  setRetrieveTokenFailure,
  setLogoutFailure,
  setLogoutLoading,
  setLogoutSuccess,
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
